import { use as i18nUse } from 'i18next'
import { initReactI18next } from 'react-i18next'
import common from './locales/en/common.json'

export const setupI18n = () => {
    i18nUse(initReactI18next) // passes i18n down to react-i18next
        .init({
            resources: {
                en: {
                    common,
                },
            },
            lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
            // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
            // if you're using a language detector, do not define the lng option
            defaultNS: 'common',
            interpolation: {
                escapeValue: false, // react already safes from xss
                format: (value, format, lng) => {
                    if (format === 'uppercase') return value.toUpperCase()
                    return value
                },
            },
            react: {
                transWrapTextNodes: 'span',
            },
        })
}
